import { Telefono } from './../../../../../../_entities/telefonos/telefono';
import { Micromedidor } from './../../../../../../_entities/micromedidores/micromedidor';
import { Medidores } from './../../../../../../_entities/medidores/Medidores';
import { TelefonosService } from './../../../../services/telefonos.service';
import { MicromedidoresService } from './../../../../services/micromedidores.service';
import { MedidoresService } from './../../../../services/medidores.service';
import { async } from '@angular/core/testing';
import { Permiso } from './../../../../../../_entities/Enums/permiso.enum';
import { Activo } from './../../../../../../_entities/activos/activo';
import { ActivosService } from './../../../../services/activos.service';
import { MatDialogRef } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { GeocercasService } from './../../../../services/geocercas.service';
import { VehiculosService } from './../../../../services/vehiculos.service';
import { MapaService } from './../../../../services/mapa.service';
import { Autos } from './../../../../../../_entities/autos/Autos';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../../../../auth/auth.service';
import {Categorias} from '../../../../../../_entities/geocerca/Categorias';
@Component({
	selector: 'kt-guardar-geocerca',
	templateUrl: './guardar-geocerca.component.html',
	styleUrls: ['./guardar-geocerca.component.scss']
})
export class GuardarGeocercaComponent implements OnInit {

	public permisoVisualizarVehiculos: string;
	public permisoVisualizarActivos: string;
	public permisoVisualizarMedidores: string;
	public permisoVisualizarMicromedidores: string;
	public permisoVisualizarTelefonos: string;

	public categorias;
	public over: string = '*';
	public esCasaLey: boolean = false;
	public geoJson: any;
	public geoJson4326: any;
	public selection = new SelectionModel<any>(true, []);
	public geoForm: FormGroup;
	public displayedColumns: string[] = ['id'];
	public vehiculosDataSource: any;
	public activosDataSource: any;
	public medidoresDataSource: any;
	public micromedidoresDataSource: any;
	public telefonosDataSource: any;
	public dataFeature: any;
	public eventoAPI = 'POST';
	public titulo = 'Agregar Geocerca';
	public elementos = [];
	public showFilterRow: boolean;
	public showHeaderFilter: boolean;
	public HWuser;

	constructor(private mapaServicio: MapaService,
		private authService: AuthService,
		private fb: FormBuilder,
		private serviceAuto: VehiculosService,
		private activosService: ActivosService,
		private medidoresService: MedidoresService,
		private micromedidoresService: MicromedidoresService,
		private telefonosService: TelefonosService,
		private geoService: GeocercasService,
		private toastr: ToastrService,
		public dialogRef: MatDialogRef<GuardarGeocercaComponent>) {
		this.showFilterRow = true;
		this.showHeaderFilter = true;
	}

	async ngOnInit() {
		this.HWuser = this.authService.getHWUser();
		let user = this.authService.getUser();

		if(user.id == '74bc5a50-65cd-4fa3-9a68-99886b468b6b') {
			this.esCasaLey = true;
			this.obtenerCategorias();
		} else {
			this.inicializarFormularios();
		}

		this.obtenerPermisos();
		this.geoJson = this.mapaServicio.nuevaGeoCerca;
		this.geoJson4326 = this.mapaServicio.nuevaGeoCerca4326;
		this.dataFeature = this.mapaServicio.dataFeature;

		if (this.dataFeature != undefined) {
			this.eventoAPI = 'PUT';
			this.titulo = 'Guardar Geocerca';
		}

		this.inicializarFormularios();

		await this.obtenerAutos().then(() => {});
		await this.obtenerActivos().then(() => { });
		await this.obtenerMedidores().then(() => { });
		await this.obtenerMicromedidores().then(() => { });
		await this.obtenerTelefonos().then(() => { });

		this.dialogRef.afterClosed().subscribe(() => {
			this.mapaServicio.mostrarVehiculos();
		});
	}

	inicializarFormularios() {
		if (this.eventoAPI == 'PUT') {
			this.updateForm();
		} else if (this.eventoAPI == 'POST') {
			this.initForm();
		}
	}

	public initForm() {
		this.mapaServicio.esGeocerca = false;
		this.geoForm = this.fb.group(
			{
				nombre: ['', Validators.compose([
					Validators.required,
					Validators.minLength(1),
					Validators.maxLength(100)
				])],
				descripcion: [''],
				IdCategoriaGeo:[''],
				geoJSON: [this.geoJson],
				geoJSON4326: [this.geoJson4326],
				vehiculos: [this.elementos]
			}
		);
	}

	updateForm() {
		this.elementos = this.dataFeature.vehiculos;
		this.geoForm = this.fb.group(
			{
				nombre: [this.dataFeature.nombre],
				descripcion: [this.dataFeature.descripcion],
				IdCategoriaGeo : [''],
				geoJSON: [this.geoJson],
				geoJSON4326: [this.geoJson4326],
				vehiculos: [this.elementos]
			}
		);
	}


	obtenerCategorias() {
		this.geoService.obtenerCategorias().subscribe(
			(categorias: Categorias[]) => {
				this.categorias = categorias;
			}
		)
	}

	public async obtenerAutos() {
		/*let token = '';
		if(this.HWuser) {
			token = this.HWuser.token
		}*/
		this.serviceAuto.obtenerAutos().subscribe(
			(datosAuto: Autos[]) => {
				this.vehiculosDataSource = datosAuto;
			}, err => {
				console.log(err);
			}
		);
	}

	public async obtenerActivos() {
		this.activosService.obtenerActivos().subscribe(
			(activos: Activo[]) => {
				this.activosDataSource = activos;
			}, err => {
				console.log(err);
			}
		);
	}

	public async obtenerMedidores() {
		this.medidoresService.obtenerMedidores().subscribe(
			(medidores: Medidores[]) => {
				this.medidoresDataSource = medidores;
			}, (error) => {
				console.log(error);
			}
		)
	}

	public async obtenerMicromedidores() {
		this.micromedidoresService.obtenerMicromedidores().subscribe(
			(micromedidores: Micromedidor[]) => {
				this.micromedidoresDataSource = micromedidores;
			}, (error) => {
				console.log(error);
			}
		)
	}

	public async obtenerTelefonos() {
		this.telefonosService.obtenerTelefonos().subscribe(
			(telefonos: Telefono[]) => {
				this.telefonosDataSource = telefonos;
			}, (error) => {
				console.log(error);
			}
		)
	}

	onSubmit() {
		if (this.geoForm.valid) {
			if (this.eventoAPI == 'POST') {
				this.geoService.postGeoCerca(this.geoForm.value).subscribe(success => {
					this.toastr.success('Se guardaron los datos', 'Éxito');
					this.resetForm();
					this.mapaServicio.mostrarVehiculos();
					location.reload()
					this.dialogRef.close();
				}, err => {
					if (this.elementos.length == 0) {
						this.toastr.error('Se necesita al menos registrar un dato', 'Error')
					}
					this.toastr.error('' + err, 'Error');
					//this.dialogRef.close();
				});
			} else if (this.eventoAPI == 'PUT') {
				this.geoService.putGeoCerca(this.geoForm.value, this.dataFeature.id).subscribe(success => {
					this.toastr.success('Se guardaron los datos', 'Éxito');
					this.resetForm();
					this.mapaServicio.mostrarVehiculos();
					this.dialogRef.close();
					location.reload()
				}, err => {
					if (this.elementos.length == 0) {
						this.toastr.error('Se necesita al menos registrar un dato', 'Error')
					}
					this.toastr.error('' + err, 'Error')
				});
			}
		} else {
			this.toastr.error('Faltan campos requeridos por llenar')
		}

	}

	public async agregarElemento(id: number) {
		if (this.elementos.includes(id)) {
			let idx = this.elementos.findIndex(x => x == id);
			this.elementos.splice(idx, 1);
		} else {
			this.elementos.push(id);
		}
	}

	toggleCheckBox(elementId) {
		return (this.elementos.findIndex(x => x == elementId) == -1) ? false : true;
	}


	resetForm() {
		this.geoForm = this.fb.group(
			{
				nombre: [''
				],
				descripcion: [''
				],
				geoJSON: [[]],
				vehiculos: [[]]
			}
		);
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.mapaServicio.mostrarVehiculos();
		this.dialogRef.close();
	}

	public get Permiso() {
		return Permiso;
	}

	obtenerPermisos() {
		this.permisoVisualizarActivos = Permiso.ConsultarActivo;
		this.permisoVisualizarVehiculos = Permiso.VisualizarVehiculos;
		this.permisoVisualizarMedidores = Permiso.VisualizarMedidores;
		this.permisoVisualizarMicromedidores = Permiso.ConsultarMicromedidor;
		this.permisoVisualizarTelefonos = Permiso.ConsultarTelefono;
	}

}
